import { transparentize, getColor, mode } from '@chakra-ui/theme-tools';
const getDefaults = (props) => {
    const { colorScheme } = props;
    return {
        focusBorderColor: props.focusBorderColor || mode(`${colorScheme}.500`, `${colorScheme}.400`)(props),
        errorBorderColor: props.errorBorderColor || mode(`${colorScheme}.500`, `${colorScheme}.400`)(props),
    };
};
const getGrayStyle = (props) => {
    const { theme } = props;
    return {
        borderColor: mode(transparentize(`gray.500`, 0.24)(theme), transparentize(`white`, 0.24)(theme))(props),
        _hover: {
            borderColor: mode(transparentize(`gray.500`, 0.48)(theme), transparentize(`white`, 0.48)(theme))(props),
        },
        _focus: {
            borderColor: mode('blue.500', 'blue.300')(props),
            boxShadow: `0 0 0 2px ${getColor(theme, transparentize('blue.400', 0.24)(theme))}`,
        },
        _invalid: {},
        _placeholder: {
            color: mode(transparentize(`gray.500`, 0.36)(theme), transparentize(`white`, 0.36)(theme))(props),
            opacity: 1,
        },
    };
};
export const getOutlineStyle = (props) => {
    const { colorScheme, theme } = props;
    const { focusBorderColor } = getDefaults(props);
    const grayFieldColorOverwrites = colorScheme === 'gray' || !colorScheme ? getGrayStyle(props) : {};
    const borderColor = mode(`${colorScheme}.500`, `${colorScheme}.400`)(props);
    return {
        field: {
            border: '1px solid',
            borderColor: getColor(theme, borderColor),
            bg: mode('white', transparentize(`white`, 0.04)(theme))(props),
            _hover: {},
            _disabled: {
                cursor: 'not-allowed',
                opacity: 1,
                color: mode(transparentize(`gray.500`, 0.16)(theme), transparentize(`white`, 0.04)(theme))(props),
                bg: mode(transparentize(`gray.50`, 0.5)(theme), transparentize(`white`, 0.08)(theme))(props),
                borderColor: mode(transparentize(`gray.500`, 0.16)(theme), transparentize(`white`, 0.16)(theme))(props),
                _hover: {
                    borderColor: 'inherit',
                },
            },
            _invalid: {
                boxShadow: 'none',
                _focus: {
                    boxShadow: `0 0 0 2px ${getColor(theme, mode(transparentize(`${colorScheme}.300`, 0.24)(theme), transparentize(`${colorScheme}.400`, 0.24)(theme))(props))}`,
                },
            },
            _focus: {
                zIndex: 1,
                borderColor: getColor(theme, focusBorderColor),
                boxShadow: `0 0 0 2px ${getColor(theme, mode(transparentize(`${colorScheme}.300`, 0.24)(theme), transparentize(`${colorScheme}.400`, 0.24)(theme))(props))}`,
            },
            ...grayFieldColorOverwrites,
        },
    };
};
const sizes = {
    xl: {
        field: {
            fontSize: 'lg',
            paddingX: 3,
            height: '3rem',
            borderRadius: 'base',
        },
    },
    lg: {
        field: {
            fontSize: 'lg',
            paddingX: 3,
            height: '2.625rem',
            borderRadius: 'base',
        },
    },
    md: {
        field: {
            fontSize: 'lg',
            paddingX: 3,
            height: '2.25rem',
            borderRadius: 'base',
        },
    },
    sm: {
        field: {
            fontSize: 'md',
            paddingX: 3,
            height: '1.875rem',
            borderRadius: 'base',
        },
    },
};
const parts = ['filed', 'addon'];
const baseStyle = {
    field: {
        width: '100%',
        outline: 0,
        lineHeight: 1,
        transition: 'all 250ms',
    },
};
const defaultProps = {
    size: 'md',
    variant: 'outline',
    colorScheme: 'gray',
};
const variants = {
    outline: getOutlineStyle,
};
export default {
    parts,
    baseStyle,
    sizes,
    variants,
    defaultProps,
};
//# sourceMappingURL=input.js.map